<template>
  <div
    id="app"
    style="background: #EEEEEE;"
  >
    <v-app>
      <v-navigation-drawer
        v-if="loggedIn"
        :value="!$vuetify.breakpoint.xs"
        touchless
        dark
        app
        width="125"
        :mobile-break-point="600"
        style="box-shadow: inset -7px 0 9px -7px rgba(0,0,0,0.7);overflow-y: auto;"
      >
        <div style="min-height: 700px;position:relative;height:100%;">
          <div
            style="width: 100%;height: 100%; max-height: 125px;"
          >
            <img
              :src="iconUrl"
              style="max-width: 100%;padding: 20px;max-height: 100%;"
              alt="Firm Icon"
            />
          </div>
          <div
            class="nav-item"
            :class="{ 'active-nav': $route.name == 'Home'}"
            @click="toRoute('Home')"
          >
            <v-icon
              class="nav-icon"
            >
              mdi-home
            </v-icon>
            <span
              class="nav-text"
            >
              Home
            </span>
          </div>
          <div
            class="nav-item"
            :class="{ 'active-nav': $route.name == 'Cases'}"
            @click="toRoute('Cases')"
          >
            <v-icon
              class="nav-icon"
            >
              mdi-briefcase
            </v-icon>
            <span
              class="nav-text"
            >
              My Cases
            </span>
          </div>
          <div
            class="nav-item"
            :class="{ 'active-nav': $route.name == 'Messages'}"
            @click="toRoute('Messages')"
          >
            <v-icon
              class="nav-icon"
            >
              mdi-forum
            </v-icon>
            <span
              class="nav-text"
            >
              Messages
            </span>
          </div>
          <div
            class="nav-item"
            :class="{ 'active-nav': $route.name == 'Files'}"
            @click="toRoute('Files')"
          >
            <v-icon
              class="nav-icon"
            >
              mdi-file-cloud
            </v-icon>
            <span
              class="nav-text"
            >
              Files
            </span>
          </div>
          <div
            class="nav-bottom"
            style="position: absolute;bottom:25px;left:0;right:0;"
          >
            <div
              class="nav-item"
              :class="{ 'active-nav': $route.name == 'Settings'}"
              @click="toRoute('Settings')"
            >
              <v-icon
                class="nav-icon"
              >
                mdi-cog
              </v-icon>
              <span
                class="nav-text"
              >
                Settings
              </span>
            </div>
            <div
              class="nav-item logout"
              @click="logOut()"
            >
              <v-icon
                size="16"
                style="padding-right: 3px;"
              >
                mdi-logout-variant
              </v-icon>
              {{ isMobileApp() ? 'Exit' : 'Log Out' }}
            </div>
          </div>
        </div>
      </v-navigation-drawer>
      <v-content
        :class="{'mobile-content': $vuetify.breakpoint.xs}"
      >
        <v-expand-transition>
          <div
            v-if="banner && !banner_hide"
            :class="banner.type"
            style="color: white;padding: 10px 25px 10px 25px;"
          >
            <div
              style="margin:auto;max-width: 1400px;"
            >
              <div
                v-if="banner.icon"
                style="display:inline-block; padding: 0 20px 0 0;"
              >
                <v-icon
                  dark
                  size="32"
                >
                  {{ banner.icon }}
                </v-icon>
              </div>
              <div
                style="display:inline-block;"
              >
                <b>{{ 'title' in banner ? banner.title : "Service Alert" }}</b><br />
                {{ 'message' in banner ? banner.message : "A service alert is active, and you may experience degraded performance. We're working to resolve the issues as soon as possible." }}
              </div>
              <div
                style="display:inline;float:right;"
              >
                <v-btn
                  v-if="'action_button' in banner"
                  small
                  outline
                  dark
                  :href="banner.action_button.link"
                >
                  {{ banner.action_button.text }}
                </v-btn>
                <v-btn
                  v-if="banner.dismissible"
                  small
                  icon
                  dark
                  @click="banner_hide = true"
                >
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </div>
              <div
                style="clear:both"
              >
              </div>
            </div>
          </div>
        </v-expand-transition>
        <router-view
          style="overflow-x: auto;"
          :logo="logoUrl"
          :icon="iconUrl"
          @showPrivacyPolicy="showPrivacyPolicy = true"
          :support_phone.sync="support_phone"
          :support_email.sync="support_email"
          :offline="offline"
          :version="version"
          @logout="doLogOut()"
        ></router-view>
      </v-content>
      <v-bottom-nav
        v-if="$vuetify.breakpoint.xs && loggedIn"
        :value="$vuetify.breakpoint.xs"
        class="mobile-nav"
        app
        fixed
        color="white"
      >
        <v-btn
          color="primary"
          flat
          :to="{'name': 'Home'}"
        >
          <span>Home</span>
          <v-icon>mdi-home</v-icon>
        </v-btn>

        <v-btn
          color="primary"
          flat
          :to="{'name': 'Cases'}"
        >
          <span>Cases</span>
          <v-icon>mdi-briefcase</v-icon>
        </v-btn>

        <v-btn
          color="primary"
          flat
          :to="{'name': 'Messages'}"
        >
          <span>Messages</span>
          <v-icon>mdi-forum</v-icon>
        </v-btn>

        <v-btn
          color="primary"
          flat
          :to="{'name': 'Settings'}"
        >
          <span>Settings</span>
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </v-bottom-nav>
    </v-app>

    <ErrorDialog
      :error="error"
      />

    <TimeOutDialog
      v-if="showTimeOut"
      @logout="timeOut()"
      v-on:refresh="showTimeOut = false; refreshAction()"
      />

    <NewVersionDialog
      v-if="showForceRefresh"
      />

    <MaintDialog
      v-if="maintdialogVisible"
      />

    <v-snackbar
      :value="showRecommendRefresh"
      bottom
      :timeout="0"
      vertical
    >
      There is a new version of {{ app_name }} available. It is recommended you refresh the page.
      <v-btn
        flat
        @click="$router.go()"
      >
        Refresh
      </v-btn>
    </v-snackbar>

    <v-snackbar
      :value="offline"
      bottom right
      color="red"
      dark
      :timeout="0"
    >
      It appears you are offline. Check your connection.
    </v-snackbar>

    <v-dialog
      v-model="showPrivacyPolicy"
      fullscreen
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <v-card-text>
          <div class="forced-content-spacer" style="height: 20vh;width: 100%;" />
          <PrivacyPolicy />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="showPrivacyPolicy = false"
            color="red"
            outline
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="mobileLogoutDialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-text
          style="text-align:center;"
        >
          <h2
            class="font-weight-light"
          >
            Log Out or Switch Accounts?
          </h2>
          <div>
          </div>
        </v-card-text>
        <v-card-actions
          style="background: #E0E0E0;"
        >
          <v-btn
            color="primary"
            @click="switchAccount();mobileLogoutDialog=false"
          >
            <v-icon
              left
            >
              mdi-account-switch
            </v-icon>
            Switch Account
          </v-btn>
          <v-btn
            color="error"
            @click="doLogOut();mobileLogoutDialog=false"
          >
            <v-icon
              left
            >
              mdi-logout-variant
            </v-icon>
            Log Out
          </v-btn>
          <v-spacer />
          <v-btn
            @click="mobileLogoutDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <RedirectDialog
      v-if="showRedirectDialog"
    />
  </div>
</template>

<script>
import ErrorDialog from '@/components/global/ErrorDialog'
import TimeOutDialog from '@/components/global/TimeOutDialog'
import NewVersionDialog from '@/components/global/NewVersionDialog'
import MaintDialog from '@/components/global/MaintDialog'
import errorHandling from '@/components/global/errorhandling.js'
import RedirectDialog from '@/components/global/RedirectDialog'
import appMixin from '@/components/global/appmixin.js'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import PrivacyPolicy from '@/components/global/PrivacyPolicy'
import api from '@/api'

export default {
  name: 'App',
  data () {
    return {
      showDrawer: true,
      showBottomNavigation: false,
      showMobileMore: false,
      support_email: null,
      support_phone: null,
      showPrivacyPolicy: false,
      mobileLogoutDialog: false,
      banner: null,
      banner_hide: true,
      showRedirectDialog: false
    }
  },
  components: {
    ErrorDialog,
    TimeOutDialog,
    NewVersionDialog,
    MaintDialog,
    PrivacyPolicy,
    RedirectDialog
  },
  mixins: [
    errorHandling,
    appMixin
  ],
  computed: {
    ...mapState('auth', [
      'name'
    ]),
    ...mapGetters('userform', [
      'uploadStatus'
    ]),
    ...mapGetters('auth', [
      'loggedIn',
      'userInfo',
      'getDomainInfo'
    ])
  },
  watch: {
    uploadStatus() {
      if (this.uploadStatus > 0 && this.uploadStatus < 100) {
        this.stopIdleTracking()
        window.onbeforeunload = function () {
          return true
        }
      } else {
        this.startIdleTracking()
        window.onbeforeunload = null
      }
    },
    loggedIn() {
      this.startTracker(this.userInfo)
    }
  },
  created () {
    if (this.user && !this.user.startsWith("client-")) {
      window.location.replace('/admin/')
    } else {
      this.getSupportInfo()
    }
    if (this.$route.query.state) {
      if (this.$route.query.event == "signing_complete")
        this.setSigned(this.$route.query.state)
    }
    let isLogin = this.$route.path.includes("login")
    if (!isLogin && this.$route.query.clredirect !== undefined) this.showRedirectDialog = true
  },
  beforeCreate () {
    api.auth.organization.getInfo()
      .then((info) => {
        this.setDomainInfo(info)
        this.startTracker(this.userInfo)
        if('banner' in info){
          this.banner = info['banner']
          if(this.banner.show_client){
            this.banner_hide = false
          }
        }
      })
  },
  methods: {
    ...mapMutations('auth', [
      'setDomainInfo',
    ]),
    ...mapMutations('userform', [
      'setSigned',
    ]),
    ...mapActions('auth', {
      logOutAction: 'logOut'
    }),
    getSupportInfo() {
      api.auth.organization.getSupport()
      .then((response) => {
        this.support_email = response.email
        this.support_phone = response.phone
      })
    },
    doLogOut () {
      this.logOutAction()
        .then(() => {
          this.postMobileMessage("logOut")
          this.$router.push({ name: 'Login' })
        })
    },
    timeOut () {
      if (this.isMobileApp())
        this.postMobileMessage("timeOut")
      else
        this.doLogOut()
    },
    logOut () {
      if (this.isMobileApp()) {
        this.mobileLogoutDialog = true
      } else {
        this.doLogOut()
      }
    },
    switchAccount () {
      this.postMobileMessage("switchAccount")
    },
    isRoute(name) {
      return this.$route.name == name
    },
    toRoute(name) {
      this.$router.replace({ name: name })
    },
  }
}
</script>

<style>
  .theme--light.application {
      background: none !important;
  }

  .v-content.mobile-content {
    padding: 0px 0px calc(56px + var(--mobile-padding-bottom)) !important;
  }

  .mobile-nav {
    padding-bottom: var(--mobile-padding-bottom, initial);
    height: auto !important;
  }

  .beta {
    background: repeating-linear-gradient(
      45deg,
      rgba(0,0,0,0),
      rgba(0,0,0,0) 10px,
      rgba(0,0,0,0.1) 10px,
      rgba(0,0,0,0.1) 20px
    ) !important;
  }

  .active-nav {
    background:#0D47A1 !important;
  }

  .nav-item {
    padding:18px;
    color:white;
    text-align:center;
    cursor: pointer;
    -o-transition:background 0.2s ease-in;
    -ms-transition:background 0.2s ease-in;
    -moz-transition:background 0.2s ease-in;
    -webkit-transition:background 0.2s ease-in;
    transition:background 0.2s ease-in;
  }

  .nav-item:hover {
    background: rgba(255,255,255,0.1)
  }

  .nav-icon {
    font-size: 38px !important;
  }

  .nav-text {
    display: block;
    font-size: 12px;
    padding-top: 5px;
  }

  .shadow {
    -moz-box-shadow:    3px 3px 5px 6px #ccc;
    -webkit-box-shadow: 3px 3px 5px 6px #ccc;
    box-shadow:         3px 3px 5px 6px #ccc;
  }

  .logout:hover {
    background: #B71C1C;
  }
</style>
